import { configureStore } from '@reduxjs/toolkit'
import searchReducer from './searchSlice'
import productReducer from './productSlice'
import cartReducer from './cartSlice'
import addressReducer from './addressSlice'

export default configureStore({
  reducer: {
    search: searchReducer,
    product: productReducer,
    cart: cartReducer,
    address: addressReducer,
  },
})